import React from "react";
import "jspdf-autotable";
import { useParams } from "react-router-dom";
import {
  AuditTrailPC,
  AuditTrailFilterPC
} from "../../../services/ProjectCenterServices";
import { RenderAuditTrailResourceType } from "../../../utils/CommonGroupingItem";
import AuditTrailsTable from "../../common/AuditTrailsTable";

const AuditTrail = () => {
  const {id} = useParams()

  const columnsToShow = ["Action Type", "Resource Type", "Resource Name"]

  return (
    <AuditTrailsTable
      apiFunction={AuditTrailPC}
      apiParams={{action_id: id}}
      columnsToShow={columnsToShow}
      filterArrApi={AuditTrailFilterPC}
      actionId={id}
      exportFileName={"Project Center Audit Trail"}
      isResourceNameShown={true}
      isShowingResourceTypeFilter
      renderResourceTypeFunction={RenderAuditTrailResourceType}
    />
  )
}
export default AuditTrail;
